module.exports = __webpack_public_path__ + "09f6b2ba02572f19a7d7dd2b5f6494ad.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/CenturyGothicRegular.ttf
// module id = 724
// module chunks = 0